export enum CategoryType {
  Individual = "1",
  Team = "2",
}

export enum CrossFunctionalAwardTypeEnum {
  "Innovation Award" = "1",
  "Collaboration Excellence Award" = "2",
  "Strategic Impact Award" = "3",
}
export enum CrossFunctionalTypeEnum {
  "TrailBlazer" = "1",
  "RExcellence" = "2",
}

export enum AwardTypeEnum {
  "TrailBlazer" = "1",
  "RExcellence" = "2",
  "Cross Functional Team" = "3",
  "Peer to Peer" = "4",
}

export enum ReimagineStatusEnum {
  "Pending" = "1",
  "Approved" = "2",
  "Rejected" = "3",
  "Delegate" = "4",
}
export enum RRStatusEnum {
  "Pending" = "1",
  "Approved" = "2",
  "Rejected" = "3",
}
export enum IdeaStatusSPOCEnum {
  "Yet To Start" = 1,
  "In-Progress" = 2,
  "Implemented" = 3,
}
